import { CursorPayload, SocketSubscriber } from "@features/builder/types"

type SubscribersCursorEntry = { cursor: CursorPayload; subscriber: SocketSubscriber }

export const getSubscriberCursors = (
  cursors: CursorPayload[],
  subscribers: SocketSubscriber[],
): SubscribersCursorEntry[] => {
  // TODO ms: remove when we change store @see socketIOHooks->handleLeaveRoom
  const out = new Map<string, { subscriber: SocketSubscriber; cursor: CursorPayload }>()
  const map = new Map<string, SocketSubscriber>()
  subscribers.forEach((s) => map.set(s.sid, s))
  cursors.forEach((cursor) => {
    const subscriber = map.get(cursor.sid ?? "")
    if (cursor.sid && subscriber) {
      out.set(cursor.sid, { subscriber, cursor })
    }
  })

  return Array.from(out.values())
}
